export default {
  en: {
    Exams: 'Exams',
    exams: {
      question: 'Question',
      questions: 'Questions',
      unlimited_time: 'Unlimited time',
      minutes: 'minutes',
      attempt: 'Attempt',
      score: 'Score',
      correct: 'Correct',
      min_required: 'Min required',
      duration: 'Duration',
      started: 'Started',
      created: 'Created',
      retry: 'Retry',
      print_result: 'Generate PDF',
      back_to_exams: 'Back to exams',
      in_progress: 'In progress',
      passed: 'Passed',
      failed: 'Failed',
      start_new_try: 'Start new try',
      prepare: 'Prepare'
    }
  },
  de: {
    Exams: 'Prüfungen',
    exams: {
      question: 'Frage',
      questions: 'Fragen',
      unlimited_time: 'Unbegrenzte Zeit',
      minutes: 'Minuten',
      attempt: 'Versuch',
      score: 'Ergebnis',
      correct: 'Richtig',
      min_required: 'Mindestanforderung',
      duration: 'Dauer',
      started: 'Gestartet',
      created: 'Erstellt',
      retry: 'Wiederholen',
      print_result: 'PDF generieren',
      back_to_exams: 'Zurück zu den Prüfungen',
      in_progress: 'In Bearbeitung',
      passed: 'Bestanden',
      failed: 'Nicht bestanden',
      start_new_try: 'Neuen Versuch starten',
      prepare: 'Vorbereiten'
    }
  },
  es: {
    Exams: 'Exámenes',
    exams: {
      question: 'Pregunta',
      questions: 'Preguntas',
      unlimited_time: 'Tiempo ilimitado',
      minutes: 'minutos',
      attempt: 'Intento',
      score: 'Puntaje',
      correct: 'Correctas',
      min_required: 'Mínimo requerido',
      duration: 'Duración',
      started: 'Iniciado',
      created: 'Creado',
      retry: 'Reintentar',
      print_result: 'Generar PDF',
      back_to_exams: 'Volver a los exámenes',
      in_progress: 'En progreso',
      passed: 'Aprobado',
      failed: 'Reprobado',
      start_new_try: 'Iniciar nuevo intento',
      prepare: 'Preparar'
    }
  },
  uk: {
    Exams: 'Іспити',
    exams: {
      question: 'Питання',
      questions: 'Питання',
      unlimited_time: 'Необмежений час',
      minutes: 'хвилин',
      attempt: 'Спроба',
      score: 'Результат',
      correct: 'Правильно',
      min_required: 'Мінімум необхідно',
      duration: 'Тривалість',
      started: 'Почато',
      created: 'Створено',
      retry: 'Повторити',
      print_result: 'Згенерувати PDF',
      back_to_exams: 'Назад до іспитів',
      in_progress: 'Виконується',
      passed: 'Склав',
      failed: 'Не склав',
      start_new_try: 'Почати нову спробу',
      prepare: 'Підготуватись'
    }
  }
}
